

























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";
import store from "@/store";

declare var grecaptcha: any;

@Component({
	components: {
		VueRecaptcha,
	},
})
export default class App extends Vue {

	private readonly links: { [name: string]: string} = {
		mail: "mailto:reg@lakesidefurs.at",
		tg: "https://t.me/+SSgKIXfkEFhr9eQi",
		tg_info: "https://t.me/LSFInfo",
		discord: "https://discord.gg/5gsRYXu",
		nievaris: "mailto:nievarisart@gmail.com",
		nievaris_tg: "https://www.t.me/NievarisKitsune",
		athalean_tg: "https://www.t.me/Athalean",
		sneakpaw_tg: "https://www.t.me/Sneakpaw",
		yukon: "mailto:yukon85@hotmail.com",
		yukon_tg: "https://www.t.me/YukonWolf",
		sarex_tg: "https://www.t.me/srxit",
		kay_tg: "https://www.t.me/KayPy",
		karakina_tg: "https://www.t.me/Karakina",
	};

	constructor() {
		super();
	}

	public openProtectedLink(name: string) {
		const link = this.links[name];
		grecaptcha.execute();
		const fnRetry = (i: number) => {
			if ((window as any).___captcha !== null)
				window.open(link);
			else if (i > 0)
				return setTimeout(() => fnRetry(i - 1), 500);
			else
				(window as any).___captcha_callback = () => {
					(window as any).___captcha_callback = undefined;
					fnRetry(3);
				};
		};
		fnRetry(3);
	}

}
